import type { IObjectOptions } from "fabric/fabric-impl";
import { TextOptions } from "../types/textTypes";
import { ImageOptions } from "../types/imageTypes";

export const OBJECT_TYPE = {
  text: "text",
  image: "image",
  background: "background",
} as const;

export const FONT_FAMILIES_LIST = [
  "Times New Roman",
  "Arial",
  "Verdana",
  "Georgia",
  "Comic Sans MS",
  "Impact",
] as const;

export const DEFAULT_IMAGE_OPTIONS: Omit<ImageOptions, "width" | "height" | "top" | "left"> = {
  angle: 0,
  stroke: "rgba(255, 255, 255, 1)",
  strokeWidth: 0,
  opacity: 1,
};

export const DEFAULT_TEXT_OPTIONS: TextOptions = {
  fill: "rgba(0, 0, 0, 1)",
  stroke: "rgba(0, 0, 0, 1)",
  strokeWidth: 0,
  fontSize: 64,
  fontFamily: FONT_FAMILIES_LIST[0],
  fontStyle: "normal",
  fontWeight: "normal",
  width: 120,
  textAlign: "center",
  opacity: 1,
  angle: 0,
  top: 180,
  left: 320,
  underline: false,
  linethrough: false,
};

export const ADDITIONAL_CANVAS_FIELDS = {
  selectable: "selectable",
  evented: "evented",
  crossOrigin: "crossOrigin",
  // Custom fields
  meaning: "meaning",
  polygonShapeName: "polygonShapeName",
  backgroundImageFillMode: "backgroundImageFillMode",
} as const;
export const CANVAS_PADDING = 24;

// Custom events
export const CANVAS_INITIALIZED_EVENT = "canvas:initialized";
export const VIEWPORT_MODIFIED_EVENT = "viewport:modified";
export const LAYER_CHANGED_EVENT = "layer:changed";
export const RESTORED_FROM_HISTORY_EVENT = "history:restored";
export const START_HISTORY_TRANSACTION_EVENT = "history:start-transaction";
export const END_HISTORY_TRANSACTION_EVENT = "history:end-transaction";

export const OBJECT_MODIFYING_THROTTLE_TIME = 1;

export const CANVAS_CUSTOM_PROPERTIES_FIELD = Symbol("canvasCustomPropertiesField");

export const FABRIC_JS_CANVAS_VERSION = "5.3.0";

export const BASE_ORIGIN_OPTIONS: Pick<IObjectOptions, "originX" | "originY"> = {
  originX: "center",
  originY: "center",
};
